import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=d8c63a14&scoped=true"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"
import style0 from "./Screenshots.vue?vue&type=style&index=0&id=d8c63a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c63a14",
  null
  
)

export default component.exports